const initialState = []

const schoolReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SCHOOLS':
            return action.payload
        default:
            return state
    }
}

export default schoolReducer